import { API_URLS, getJSONData } from '@/lib/api/config';

let cachedAnonymousUserPromise: Promise<{
  ok: boolean;
  code: number;
  headers: Headers;
  data: any;
}> | null = null;

export function clearAnonymousUserCache() {
  cachedAnonymousUserPromise = null;
}

export async function getLoveveryAnonymousUser() {
  if (cachedAnonymousUserPromise) {
    return cachedAnonymousUserPromise;
  }

  cachedAnonymousUserPromise = (async () => {
    try {
      // important note: the credentials flag enables cookies to be sent along with the request
      // this is necessary for the account manager API to be able to set the lovevery_id cookie
      const response = await fetch(
        `${API_URLS.ACCOUNT_MANAGER_PROXY}/anonymous_users`,
        {
          method: 'POST',
          credentials: 'include',
        },
      );
      const data = await getJSONData(response);

      // Clear the cached promise so subsequent calls will make a new request
      cachedAnonymousUserPromise = null;

      return {
        ok: response.ok,
        code: response.status,
        headers: response.headers,
        data: data,
      };
    } catch (error) {
      console.error('Error in getLoveveryAnonymousUser:', error);
      // Clear the cached promise on error so subsequent calls will try again
      cachedAnonymousUserPromise = null;
      throw error;
    }
  })();

  return cachedAnonymousUserPromise;
}

export async function createAnonymousUser(loveveryId: string) {
  const response = await fetch(`${API_URLS.ACCOUNT_MANAGER}/anonymous_users`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ uuid: loveveryId }),
  });

  return {
    ok: response.ok,
    code: response.status,
    headers: response.headers,
    data: await getJSONData(response),
  };
}
